// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and base styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
  color: #333;
  line-height: 1.6;
}

.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Header */
.App-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 2rem 1rem;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.App-header h1 {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.App-header p {
  font-size: 1.1rem;
  opacity: 0.9;
}

/* Notes Alert */
.notes-alert {
  background: #fff3cd;
  border: 1px solid #f39c12; /* #ffeaa7;*/
  /*border-left: 4px solid #f39c12;*/
  margin: 0.5rem auto;
  width: 1200px;
  padding: 1.5rem;
  border-radius: 12px;
}

.notes-alert h3 {
  color: #856404;
  margin: 0 0 1rem 0;
  font-size: 1.2rem;
  font-weight: 600;
}

.notes-alert p {
  color: #856404;
  margin: 0 0 1rem 0;
  font-size: 1rem;
  line-height: 1.5;
}

.notes-alert ul {
  color: #856404;
  margin: 0;
  padding-left: 1.5rem;
}

.notes-alert li {
  margin-bottom: 0.5rem;
  line-height: 1.5;
}

.notes-alert strong {
  color: #6c5ce7;
  font-weight: 600;
}

/* Main content */
.App-main {
  flex: 1 1;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.input-section {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  border: 1px solid #e1e5e9;
}

/* Portfolio Input */
.portfolio-input h2 {
  color: #2d3748;
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 0.5rem;
}

.input-section label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #4a5568;
}

.input-section input[type="number"] {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.2s;
}

.input-section input[type="number"]:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.allocation-mode {
  display: flex;
  gap: 2rem;
  margin: 1.5rem 0;
  background: #f7fafc;
  border-radius: 8px;
}

.allocation-mode label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0;
  cursor: pointer;
}

.allocation-mode input[type="radio"] {
  margin: 0;
}


.income-input h2 {
  color: #2d3748;
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 0.5rem;
}

.spending-input h2 {
  color: #2d3748;
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 0.5rem;
}

.error {
  color: #e53e3e;
  font-weight: normal;
}

/* Withdrawal Input */
.withdrawal-input h2 {
  color: #2d3748;
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 0.5rem;
}

.input-group {
  margin-bottom: 1.5rem;
}

.input-group small {
  display: block;
  margin-top: 0.25rem;
  color: #718096;
  font-size: 0.875rem;
}

.chart-legend {
  background: #f7fafc;
  padding: 1.5rem;
  border-radius: 8px;
  margin-top: 1rem;
}

.chart-legend h3 {
  color: #2d3748;
  margin-bottom: 1rem;
}

.chart-legend ul {
  list-style: none;
  padding: 0;
}

.chart-legend li {
  padding: 0.25rem 0;
  color: #4a5568;
}

/* Simulation Section */
.simulation-section {
  text-align: center;
  margin: 2rem 0;
}

.run-simulation-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.run-simulation-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.15);
}

.run-simulation-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.simulation-duration {
  /*color: #718096;*/
  font-size: 1.25rem;
  margin-top: 0.5rem;
  text-align: center;
  font-style: italic;
}

.error-message {
  background: #fed7d7;
  color: #742a2a;
  padding: 1rem;
  border-radius: 8px;
  margin-top: 1rem;
  border: 1px solid #feb2b2;
}

/* Chart Section */
.results-section {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  border: 1px solid #e1e5e9;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.chart-header h2 {
  color: #2d3748;
  font-size: 1.5rem;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 0.5rem;
  margin: 0;
  flex: 1 1;
  min-width: 200px;
}

.chart-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.simulation-selector {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.simulation-selector label {
  font-weight: 500;
  color: #555;
}

.simulation-selector select {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  font-size: 0.9rem;
  min-width: 120px;
}

.simulation-selector select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

.scale-toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-weight: 500;
  color: #4a5568;
  padding: 0.5rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  transition: all 0.2s;
}

.scale-toggle:hover {
  border-color: #667eea;
  background: #f7fafc;
}

.scale-toggle input[type="checkbox"] {
  margin: 0;
  width: 18px;
  height: 18px;
  accent-color: #667eea;
}

.log-scale-note {
  color: #667eea;
  font-style: italic;
  font-weight: 500;
}

.custom-tooltip {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.tooltip-label {
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.custom-tooltip p {
  margin: 0.25rem 0;
  font-size: 0.875rem;
}

.chart-description {
  color: #4a5568;
  margin-bottom: 2rem;
  font-size: 1rem;
}

.chart-wrapper {
  margin-bottom: 2rem;
}

.loading {
  text-align: center;
  padding: 4rem;
  color: #718096;
  font-size: 1.1rem;
}

.no-data {
  text-align: center;
  padding: 4rem;
  color: #718096;
  font-size: 1.1rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .App-header h1 {
    font-size: 2rem;
  }
  
  .App-main {
    padding: 1rem;
  }
  
  .input-section {
    padding: 1.5rem;
  }
  
  
  .allocation-mode {
    flex-direction: column;
    gap: 1rem;
  }
  
  .chart-header {
    flex-direction: column;
    align-items: stretch;
  }
  
  .chart-controls {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .App-header {
    padding: 1.5rem 1rem;
  }
  
  .App-header h1 {
    font-size: 1.75rem;
  }
  
  .input-section {
    padding: 1rem;
  }
  
  .run-simulation-btn {
    padding: 0.875rem 1.5rem;
    font-size: 1rem;
  }
}

/* Portfolio Grid Layout - Transposed */
.portfolio-grid {
  display: grid;
  grid-template-columns: 190px repeat(3, 200px);
  gap: 1rem;
  margin-top: 1.5rem;
  align-items: center;
}

.grid-header {
  display: contents;
}

.grid-header > div {
  font-weight: 600;
  color: #4a5568;
  padding: 0.75rem 0.5rem;
  border-bottom: 2px solid #e2e8f0;
  text-align: center;
}

.balance-header {
  align-self: flex-end;
  text-align: right !important;
}

.asset-row {
  display: contents;
}

.totals-row {
  display: contents;
  background-color: #f8f9fa;
  border-top: 2px solid #e2e8f0;
}

.asset-name {
  display: flex;
  align-items: center;
  padding: 0.75rem 0.5rem;
  font-weight: 500;
  color: #2d3748;
}

.asset-name label {
  margin: 0;
}

.account-header {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
  text-align: center;
}

.account-name {
  font-weight: 500;
  color: #2d3748;
  font-size: 0.9rem;
  line-height: 1.2;
}

.account-balance {
  width: 100%;
}

.account-balance input {
  width: 100%;
  padding: 0.4rem;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 0.8rem;
  text-align: center;
}

.account-balance input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 1px rgba(102, 126, 234, 0.2);
}

.allocation-cell {
  padding: 0.5rem;
  text-align: center;
}

.allocation-input-container {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.allocation-input-container input {
  width: 100%;
  padding: 0.4rem;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 0.85rem;
  text-align: center;
}

.allocation-input-container input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 1px rgba(102, 126, 234, 0.2);
}

.allocation-display {
  font-size: 0.7rem;
  color: #718096;
  min-height: 1rem;
}

.amount-display, .percentage-display {
  display: block;
  font-weight: 500;
}

.account-total-cell {
  padding: 0.5rem;
  text-align: center;
}

.account-total-display {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.account-total-display.valid .account-total-percentage,
.account-total-display.valid .account-total-amount {
  color: #38a169;
  font-weight: 600;
}

.account-total-display.invalid .account-total-percentage,
.account-total-display.invalid .account-total-amount {
  color: #e53e3e;
  font-weight: 600;
}

.account-total-display .error {
  font-size: 0.6rem;
  color: #e53e3e;
  font-weight: 500;
}

.totals-label {
  display: flex;
  align-items: center;
  padding: 0.75rem 0.5rem;
  font-weight: 600;
  color: #2d3748;
}

/* Cash Savings Section */
.portfolio-input-section {
  margin-top: 1rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.cash-savings-content {
  display: flex;
  gap: 2rem;
  align-items: flex-end;
}

.cash-balance {
  /*flex: 1;*/
  display: flex;
  gap: 2rem;
  flex-direction: row;
  align-items: center;
}

.cash-balance label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  text-align: right;
  text-wrap: nowrap;
  color: #4a5568;
}

.cash-balance input {
  width: 200px;
  padding: 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.2s;
}

.cash-balance input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}


/* Responsive grid adjustments */
@media (max-width: 1200px) {
  .portfolio-grid {
    grid-template-columns: 130px repeat(3, 160px);
    gap: 0.75rem;
  }
}

@media (max-width: 900px) {
  .portfolio-grid {
    grid-template-columns: 120px repeat(3, 140px);
    gap: 0.5rem;
  }
  
  .allocation-input-container input {
    font-size: 0.8rem;
    padding: 0.3rem;
  }
  
  .allocation-display {
    font-size: 0.65rem;
  }
  
  .account-name {
    font-size: 0.8rem;
  }
  
  .account-balance input {
    font-size: 0.75rem;
    padding: 0.3rem;
  }
  
  .cash-savings-content {
    flex-direction: column;
    gap: 1rem;
  }
  
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,yBAAyB,EAAE,YAAY;EACvC,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;;AAGA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,eAAe;EACjB;AACF;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,6CAA6C;EAC7C,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;;AAGA,gCAAgC;AAChC;EACE;IACE,6CAA6C;IAC7C,YAAY;EACd;AACF;;AAEA;EACE;IACE,6CAA6C;IAC7C,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;AAEF","sourcesContent":["/* Reset and base styles */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f5f5f5;\n  color: #333;\n  line-height: 1.6;\n}\n\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Header */\n.App-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 2rem 1rem;\n  text-align: center;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n}\n\n.App-header h1 {\n  font-size: 2.5rem;\n  margin-bottom: 0.5rem;\n  font-weight: 700;\n}\n\n.App-header p {\n  font-size: 1.1rem;\n  opacity: 0.9;\n}\n\n/* Notes Alert */\n.notes-alert {\n  background: #fff3cd;\n  border: 1px solid #f39c12; /* #ffeaa7;*/\n  /*border-left: 4px solid #f39c12;*/\n  margin: 0.5rem auto;\n  width: 1200px;\n  padding: 1.5rem;\n  border-radius: 12px;\n}\n\n.notes-alert h3 {\n  color: #856404;\n  margin: 0 0 1rem 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.notes-alert p {\n  color: #856404;\n  margin: 0 0 1rem 0;\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n.notes-alert ul {\n  color: #856404;\n  margin: 0;\n  padding-left: 1.5rem;\n}\n\n.notes-alert li {\n  margin-bottom: 0.5rem;\n  line-height: 1.5;\n}\n\n.notes-alert strong {\n  color: #6c5ce7;\n  font-weight: 600;\n}\n\n/* Main content */\n.App-main {\n  flex: 1;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.input-section {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n  border: 1px solid #e1e5e9;\n}\n\n/* Portfolio Input */\n.portfolio-input h2 {\n  color: #2d3748;\n  margin-bottom: 1.5rem;\n  font-size: 1.5rem;\n  border-bottom: 2px solid #e2e8f0;\n  padding-bottom: 0.5rem;\n}\n\n.input-section label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  color: #4a5568;\n}\n\n.input-section input[type=\"number\"] {\n  width: 100%;\n  padding: 0.75rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: border-color 0.2s;\n}\n\n.input-section input[type=\"number\"]:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.allocation-mode {\n  display: flex;\n  gap: 2rem;\n  margin: 1.5rem 0;\n  background: #f7fafc;\n  border-radius: 8px;\n}\n\n.allocation-mode label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0;\n  cursor: pointer;\n}\n\n.allocation-mode input[type=\"radio\"] {\n  margin: 0;\n}\n\n\n.income-input h2 {\n  color: #2d3748;\n  margin-bottom: 1.5rem;\n  font-size: 1.5rem;\n  border-bottom: 2px solid #e2e8f0;\n  padding-bottom: 0.5rem;\n}\n\n.spending-input h2 {\n  color: #2d3748;\n  margin-bottom: 1.5rem;\n  font-size: 1.5rem;\n  border-bottom: 2px solid #e2e8f0;\n  padding-bottom: 0.5rem;\n}\n\n.error {\n  color: #e53e3e;\n  font-weight: normal;\n}\n\n/* Withdrawal Input */\n.withdrawal-input h2 {\n  color: #2d3748;\n  margin-bottom: 1.5rem;\n  font-size: 1.5rem;\n  border-bottom: 2px solid #e2e8f0;\n  padding-bottom: 0.5rem;\n}\n\n.input-group {\n  margin-bottom: 1.5rem;\n}\n\n.input-group small {\n  display: block;\n  margin-top: 0.25rem;\n  color: #718096;\n  font-size: 0.875rem;\n}\n\n.chart-legend {\n  background: #f7fafc;\n  padding: 1.5rem;\n  border-radius: 8px;\n  margin-top: 1rem;\n}\n\n.chart-legend h3 {\n  color: #2d3748;\n  margin-bottom: 1rem;\n}\n\n.chart-legend ul {\n  list-style: none;\n  padding: 0;\n}\n\n.chart-legend li {\n  padding: 0.25rem 0;\n  color: #4a5568;\n}\n\n/* Simulation Section */\n.simulation-section {\n  text-align: center;\n  margin: 2rem 0;\n}\n\n.run-simulation-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n}\n\n.run-simulation-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0,0,0,0.15);\n}\n\n.run-simulation-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.simulation-duration {\n  /*color: #718096;*/\n  font-size: 1.25rem;\n  margin-top: 0.5rem;\n  text-align: center;\n  font-style: italic;\n}\n\n.error-message {\n  background: #fed7d7;\n  color: #742a2a;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-top: 1rem;\n  border: 1px solid #feb2b2;\n}\n\n/* Chart Section */\n.results-section {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n  border: 1px solid #e1e5e9;\n}\n\n.chart-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.chart-header h2 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  border-bottom: 2px solid #e2e8f0;\n  padding-bottom: 0.5rem;\n  margin: 0;\n  flex: 1;\n  min-width: 200px;\n}\n\n.chart-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.simulation-selector {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.simulation-selector label {\n  font-weight: 500;\n  color: #555;\n}\n\n.simulation-selector select {\n  padding: 0.5rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n  font-size: 0.9rem;\n  min-width: 120px;\n}\n\n.simulation-selector select:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);\n}\n\n.scale-toggle {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  font-weight: 500;\n  color: #4a5568;\n  padding: 0.5rem 1rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  background: white;\n  transition: all 0.2s;\n}\n\n.scale-toggle:hover {\n  border-color: #667eea;\n  background: #f7fafc;\n}\n\n.scale-toggle input[type=\"checkbox\"] {\n  margin: 0;\n  width: 18px;\n  height: 18px;\n  accent-color: #667eea;\n}\n\n.log-scale-note {\n  color: #667eea;\n  font-style: italic;\n  font-weight: 500;\n}\n\n.custom-tooltip {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 1rem;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n}\n\n.tooltip-label {\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.custom-tooltip p {\n  margin: 0.25rem 0;\n  font-size: 0.875rem;\n}\n\n.chart-description {\n  color: #4a5568;\n  margin-bottom: 2rem;\n  font-size: 1rem;\n}\n\n.chart-wrapper {\n  margin-bottom: 2rem;\n}\n\n.loading {\n  text-align: center;\n  padding: 4rem;\n  color: #718096;\n  font-size: 1.1rem;\n}\n\n.no-data {\n  text-align: center;\n  padding: 4rem;\n  color: #718096;\n  font-size: 1.1rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .App-header h1 {\n    font-size: 2rem;\n  }\n  \n  .App-main {\n    padding: 1rem;\n  }\n  \n  .input-section {\n    padding: 1.5rem;\n  }\n  \n  \n  .allocation-mode {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .chart-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .chart-controls {\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .App-header {\n    padding: 1.5rem 1rem;\n  }\n  \n  .App-header h1 {\n    font-size: 1.75rem;\n  }\n  \n  .input-section {\n    padding: 1rem;\n  }\n  \n  .run-simulation-btn {\n    padding: 0.875rem 1.5rem;\n    font-size: 1rem;\n  }\n}\n\n/* Portfolio Grid Layout - Transposed */\n.portfolio-grid {\n  display: grid;\n  grid-template-columns: 190px repeat(3, 200px);\n  gap: 1rem;\n  margin-top: 1.5rem;\n  align-items: center;\n}\n\n.grid-header {\n  display: contents;\n}\n\n.grid-header > div {\n  font-weight: 600;\n  color: #4a5568;\n  padding: 0.75rem 0.5rem;\n  border-bottom: 2px solid #e2e8f0;\n  text-align: center;\n}\n\n.balance-header {\n  align-self: flex-end;\n  text-align: right !important;\n}\n\n.asset-row {\n  display: contents;\n}\n\n.totals-row {\n  display: contents;\n  background-color: #f8f9fa;\n  border-top: 2px solid #e2e8f0;\n}\n\n.asset-name {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem 0.5rem;\n  font-weight: 500;\n  color: #2d3748;\n}\n\n.asset-name label {\n  margin: 0;\n}\n\n.account-header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding: 0.5rem;\n  text-align: center;\n}\n\n.account-name {\n  font-weight: 500;\n  color: #2d3748;\n  font-size: 0.9rem;\n  line-height: 1.2;\n}\n\n.account-balance {\n  width: 100%;\n}\n\n.account-balance input {\n  width: 100%;\n  padding: 0.4rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  text-align: center;\n}\n\n.account-balance input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 1px rgba(102, 126, 234, 0.2);\n}\n\n.allocation-cell {\n  padding: 0.5rem;\n  text-align: center;\n}\n\n.allocation-input-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.allocation-input-container input {\n  width: 100%;\n  padding: 0.4rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  text-align: center;\n}\n\n.allocation-input-container input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 1px rgba(102, 126, 234, 0.2);\n}\n\n.allocation-display {\n  font-size: 0.7rem;\n  color: #718096;\n  min-height: 1rem;\n}\n\n.amount-display, .percentage-display {\n  display: block;\n  font-weight: 500;\n}\n\n.account-total-cell {\n  padding: 0.5rem;\n  text-align: center;\n}\n\n.account-total-display {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.account-total-display.valid .account-total-percentage,\n.account-total-display.valid .account-total-amount {\n  color: #38a169;\n  font-weight: 600;\n}\n\n.account-total-display.invalid .account-total-percentage,\n.account-total-display.invalid .account-total-amount {\n  color: #e53e3e;\n  font-weight: 600;\n}\n\n.account-total-display .error {\n  font-size: 0.6rem;\n  color: #e53e3e;\n  font-weight: 500;\n}\n\n.totals-label {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem 0.5rem;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n/* Cash Savings Section */\n.portfolio-input-section {\n  margin-top: 1rem;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.cash-savings-content {\n  display: flex;\n  gap: 2rem;\n  align-items: flex-end;\n}\n\n.cash-balance {\n  /*flex: 1;*/\n  display: flex;\n  gap: 2rem;\n  flex-direction: row;\n  align-items: center;\n}\n\n.cash-balance label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  text-align: right;\n  text-wrap: nowrap;\n  color: #4a5568;\n}\n\n.cash-balance input {\n  width: 200px;\n  padding: 0.75rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: border-color 0.2s;\n}\n\n.cash-balance input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);\n}\n\n\n/* Responsive grid adjustments */\n@media (max-width: 1200px) {\n  .portfolio-grid {\n    grid-template-columns: 130px repeat(3, 160px);\n    gap: 0.75rem;\n  }\n}\n\n@media (max-width: 900px) {\n  .portfolio-grid {\n    grid-template-columns: 120px repeat(3, 140px);\n    gap: 0.5rem;\n  }\n  \n  .allocation-input-container input {\n    font-size: 0.8rem;\n    padding: 0.3rem;\n  }\n  \n  .allocation-display {\n    font-size: 0.65rem;\n  }\n  \n  .account-name {\n    font-size: 0.8rem;\n  }\n  \n  .account-balance input {\n    font-size: 0.75rem;\n    padding: 0.3rem;\n  }\n  \n  .cash-savings-content {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
